export default __webpack_public_path__ + "static/south-america-b819195043469f31bee18aabb86e1d6a.svg";